<!--
 * @Author: DQL
 * @Date: 2022-04-09 17:02:49
 * @LastEditors: DQL
 * @LastEditTime: 2022-07-01 23:44:10
 * @Description: file content
-->
<template>
  <hm-tree-select
    class="c-form__hm-treeselect c-tree-select-wrap"
    instance-id="DeptTreeSelect"
    placeholder="请选择机构"
    loading-text="加载中..."
    retry-text="重新加载"
    retry-title="点击重新加载"
    no-children-text="没有子节点"
    no-options-text="没有可用选项"
    no-results-text="没有匹配的结果"
    search-prompt-text="查找中..."
    :append-to-body="true"
    :options="optionsList"
    :normalizer="normalizer"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'DeptTree',
  props: {
    // 自动初始化数据
    autoInit: {
      type: Boolean,
      default: false
    },
    serviceUrl: {
      type: String,
      default: null
    },
    serviceType: {
      type: String,
      default: 'deptTree'
    },
    deptType: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      /* 下拉树展示的选项 Start */
      optionsList: [
      ],
      /* 下拉树展示的选项 End */
      serviceUrlSelect: {
        deptTree: '/dept/tree',
        deptTreeOpen: '/dept/getDepts'
      }
    };
  },
  methods: {
    /**
     * @description: 转换下拉树节点字段
     * @param {type}
     * @return:
     */
    normalizer (node) {
      return {
        id: node.nodeCode,
        label: node.nodeName,
        children:
          node.childNodes && node.childNodes.length > 0 ? node.childNodes : undefined
      };
    },
    /**
     * @description: 获取下拉树数据（同步数据）
     * @param {*}
     * @return {*}
     */
    handleGetTree () {
      let serviceUrl = null;
      if (this.serviceUrl) {
        serviceUrl = this.serviceUrl;
      } else {
        serviceUrl = `${this.$config.commontCtx}${this.serviceUrlSelect[this.serviceType]}`;
        if (this.deptType) {
          serviceUrl = serviceUrl + '/' + this.deptType;
        }
      }
      this.$axios.get(serviceUrl)
        .then(rsp => {
          let data = [];
          if (!rsp.data.length && rsp.data.nodeCode === '-1') {
            data = rsp.data.childNodes;
          } else {
            data = rsp.data;
          }
          this.optionsList = data;
          if (this.autoInit && !this.$attrs.value) {
            this.$emit('input', this.$attrs.multiple ? [data[0].nodeCode] : data[0].nodeCode);
            this.$emit('initCallback', this.$attrs.multiple ? [data[0].nodeCode] : data[0].nodeCode);
          }
        });
    }
  },
  created () {
    this.handleGetTree();
  }
};
</script>
